/**
 * This method is helpful for posting form values via a fake form for a full page reload.
 */

export interface KeyValues {
  Key: string;
  Value: any;
}

/**
 * Forked from https://github.com/developit/dlv
 * @param obj
 * @param key
 */
function dlv(obj, key: string) {
  // Remove array notation, replace with dots
  const normalizedKey = key.replace(/(\[(\d*)\])/g, ".$2");

  const keys = normalizedKey.split(".");
  for (let p = 0; p < keys.length; p++) {
    obj = obj ? obj[keys[p]] : undefined;
  }

  return obj;
}

function getFlattenedKeys(obj: any, baseKey: string = ""): string[] {
  const flattenedKeys: string[] = [];
  if (obj === undefined || obj === null) {
    return [];
  }

  const objIsArray = Array.isArray(obj);

  const keys = Object.keys(obj);
  for (const key of keys) {
    const val = obj[key];

    const thisAggregateKey = baseKey
      ? objIsArray
        ? `${baseKey}[${key}]`
        : `${baseKey}.${key}`
      : key;

    //
    // Simple types
    //
    if (
      typeof val === "string" ||
      typeof val === "number" ||
      typeof val === "boolean"
    ) {
      flattenedKeys.push(thisAggregateKey);

      continue;
    }

    //
    // Array
    //
    if (Array.isArray(val)) {
      const arrFlattenedKeyValues = getFlattenedKeys(val, thisAggregateKey);
      for (const newKey of arrFlattenedKeyValues) {
        flattenedKeys.push(newKey);
      }

      continue;
    }

    //
    // Nested objects
    //
    if (typeof val === "object") {
      const objFlattenedKeyValues = getFlattenedKeys(val, thisAggregateKey);
      for (const newKey of objFlattenedKeyValues) {
        flattenedKeys.push(newKey);
      }

      continue;
    }
  }

  return flattenedKeys;
}

function getFlattenedKeyValues(obj: any): KeyValues[] {
  const flattenedKeys = getFlattenedKeys(obj);

  return flattenedKeys.map((flattenedKey) => ({
    Key: flattenedKey,
    Value: dlv(obj, flattenedKey),
  }));
}

export default getFlattenedKeyValues;
